export default function getPropertyValues(propertyName, properties) {
  return [].concat(properties?.find((property) => property.name === propertyName)?.values).filter(Boolean)
}
